export default "__VITE_ASSET__DkxKXYQ1__"